import gsap from 'gsap';

export default () => {
  const faqs = document.querySelectorAll('[component="faq"]');

  faqs.forEach((faq) => {
    const itemChildren = faq.querySelectorAll('[child="item"]');

    itemChildren.forEach((item) => {
      const bodyChildren = item.querySelector('[child="body"]');
      const headChildren = item.querySelector('[child="head"]');
      const iconVertical = item.querySelector('[child="icon-vertical"]');
      const iconHorizontal = item.querySelector('[child="icon-horizontal"]');

      const timeline = gsap.timeline({ paused: true });
      timeline.from(bodyChildren, {
        height: '0px',
        duration: 0.3,
        ease: 'power2.out',
      });

      const timelineIcon = gsap.timeline({ paused: true });
      timelineIcon
        .to(
          iconHorizontal,
          {
            rotation: 90,
            duration: 0.3,
            opacity: 0,
            ease: 'power2.out',
          },
          0
        )
        .to(
          iconVertical,
          {
            rotation: 180,
            duration: 0.3,
            ease: 'power2.out',
          },
          0
        );

      headChildren.addEventListener('click', () => {
        if (item.dataset.open === 'true') {
          // eslint-disable-next-line
          item.dataset.open = 'false';
          timeline.reverse();
          timelineIcon.reverse();
        } else {
          // eslint-disable-next-line
          item.dataset.open = 'true';
          timeline.play();
          timelineIcon.play();
        }
      });
    });
  });
};
